import '../css/style.scss';

import Nav from './modules/Nav';
import Top from './modules/Top.js';
import PopUp from './modules/PopUp';
import PopUpSlider from './modules/PopUpSlider';
import Strength from './modules/Strength';
import Flow from './modules/Flow';

const TOP_PAGE = document.querySelector('.home');

if (TOP_PAGE) {
  const top = new Top();
  const strength = new Strength();
} else {
  const flow = new Flow();
}

const nav = new Nav();
const popUp = new PopUp();
const popUpSlider = new PopUpSlider();
